import { Grid } from '@mui/material'

import { HelpButton } from './HelpButton'

interface Props {
  children?: React.ReactNode
  helpProps: { buttonSx?: object; title: string; text: React.ReactNode }
  disabled?: boolean
  version?: string
  sx?: object
}

export function HelpWrapper({ helpProps, children, disabled, sx, version }: Props) {
  return disabled ? (
    children
  ) : (
    <Grid container sx={{ ...sx, alignItems: 'center', justifyContent: 'space-between' }} columnSpacing={0}>
      <Grid size="grow">{children}</Grid>
      <HelpButton {...helpProps} version={version} />
    </Grid>
  )
}
